import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import PromoPage from "@/pages/PromoPage";
import FranchisingPage from "@/pages/FranchisingPage";
import SimulatorPage from "@/pages/SimulatorPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import AdminPage from "@/pages/AdminPage";

function ScrollManager() {
  const lenis = useLenis();
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          if (lenis) lenis.scrollTo(el, { offset: -80 });
          else el.scrollIntoView();
        }
      }, 350);
      return () => clearTimeout(id);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash, lenis]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="App bg-white text-ink font-sans">
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/promo" replace />} />
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/franchising" element={<FranchisingPage />} />
          <Route path="/simulatore" element={<SimulatorPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/promo" replace />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, anchors: { offset: -80 } }}>
          <ScrollManager />
          <AppShell />
        </ReactLenis>
      </BrowserRouter>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
